var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.picparts),function(picpart){return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(require('../../../assets/img/loading.jpeg')),expression:"require('../../../assets/img/loading.jpeg')"}],style:(_vm.getImgStyle(_vm.picSplitCount)),attrs:{"imgpath":_vm.getContentImgPath(picpart)}})}),_vm._v(" "),_c('br')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-462d95a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layer2/book/read-picture.vue
// module id = null
// module chunks = 